import {Box, Button, DialogContent, IconButton, styled, Switch, Typography} from "@mui/material";
import {color} from "../../theme/includes/color";

export const DialogUploadCloseButton = styled(IconButton)({
  padding: 0,
  position: 'absolute',
  top: '40px',
  right: '40px',
  ':hover': {
    backgroundColor: 'transparent',
  }
})

export const UploadSwitch = styled(Switch)({
  width: '120px',
  height: '55px',
  '& .MuiSwitch-switchBase': {
    padding: '2px',
    transform: 'none !important',
    left: '0px',
    '&.Mui-checked': {
      transform: 'none !important',
      left: '0px',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiSwitch-thumb': {
    width: '46px',
    height: '46px',
  },
  '& .MuiSwitch-track': {
    display: 'none',
    borderRadius: '50px',
  },
})

export const UploadColorText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ active }) => ({
    fontSize: '56px',
    justifySelf: 'start',
  ...(active
    ? {
      background: 'linear-gradient(94deg, #1131F5 43.57%, #63BAD0 87.34%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    }
    : {
      color: '#B1B4BF',
    }),
}));

export const UploadText = styled(Typography)({
  maxWidth: '180px',
  fontSize: '24px',
  color: color('blue-100'),
  justifySelf: 'center'
})

export const DialogContentActive = styled(DialogContent)<{ isDragActive?: boolean }>(({ isDragActive }) => ({
  maxHeight: '190px',
  color: color('white-100'),
  borderRadius: '16px',
  outline: '3px dashed rgba(17, 49, 245, 0.5)',
  outlineOffset: '-2px',
  textAlign: 'center',
  backgroundColor: isDragActive ? color('grey-300') : 'transparent',
  alignContent: 'center',

  cursor: 'pointer',

  '&:hover': {
    backgroundColor: color('grey-300'),
  }
}))

export const DialogContentSelected = styled(DialogContent)({
  maxHeight: '190px',
  padding: '16px',
  backgroundColor: color('grey-300'),
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'space-between',
  position: 'relative'
})

export const FileIconBox = styled(Box)({
  'svg': {
    maxWidth: '80px',
    minWidth: '80px',
    maxHeight: '80px',
    minHeight: '80px',
    'path': {
      stroke: '#B1B4BF',
    }
  }
})

export const DialogContentSelectedTitle = styled(Typography)({
  fontWeight: 400,
})

export const DialogContentSelectedSubTitle = styled(Typography)({
  fontWeight: 400,
  color: color('grey-500'),
})

export const DialogContentSelectedBin = styled(IconButton)({
  maxWidth: '40px',
  minWidth: '40px',
  maxHeight: '40px',
  minHeight: '40px',

  backgroundColor: color('white-100'),
  borderRadius: '16px',

  position: 'absolute',
  top: '16px',
  right: '16px',

  ':hover': {
    backgroundColor: color('white-100'),
  }
})

export const DialogContentText = styled(Typography)({
  color: color('grey-700'),
  marginTop: '12px',
  marginBottom: '32px'
})

export const DialogContentButton = styled(Button)({
  width: '100%',
  textTransform: 'capitalize',
})